module.exports = __webpack_public_path__ + "media/LydiaSarfati.617faccd.mp4";